import { useState } from "react";
import { useQuery } from "react-query";
import axios from "../../config/axiosInstance";
import { SUGGESTIONS } from "../../config/apiConfig";
import { Badge, Card } from "./Primitives";
import SuggestionDrawer from "./SuggestionDrawer";
import { formatDate } from "./crmHelpers";
import {
  SUGGESTION_AREA_LABELS,
  SUGGESTION_KIND_LABELS,
  SUGGESTION_STATUS_META,
} from "./suggestionHelpers";

/*
  Sugestões que esta conta mandou, na ficha. Quem vai ligar para a cliente sabe
  o que ela pediu (e se já foi atendida) antes de falar com ela.

  Aparece só quando há alguma: uma ficha sem sugestões não ganha um bloco vazio.
  Mostra também as que foram juntadas a outra, marcadas como tal.
*/

const ClientSuggestions = ({ companyId }) => {
  const [openId, setOpenId] = useState(null);

  const { data } = useQuery(
    ["suggestions", "company", companyId],
    async () => {
      const { data: response } = await axios.get(
        `${SUGGESTIONS.LIST}?companyId=${companyId}&itemsPerPage=50`
      );
      return response.data;
    }
  );

  const items = data?.suggestions || [];
  if (!items.length) return null;

  return (
    <>
      <Card className="overflow-hidden">
        <div className="border-b border-slate-100 px-4 py-3">
          <h2 className="text-sm font-bold text-slate-900">Sugestões</h2>
          <p className="text-[11px] text-slate-500">
            {items.length} enviada(s) por esta conta pelo menu do app
          </p>
        </div>

        <ul className="divide-y divide-slate-100">
          {items.map((item) => {
            const meta =
              SUGGESTION_STATUS_META[item.status] || SUGGESTION_STATUS_META.PENDING;

            return (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => setOpenId(item.id)}
                  className="flex w-full items-start gap-3 px-4 py-3 text-left transition hover:bg-slate-50/80"
                >
                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-1.5">
                      <Badge tone={meta.tone}>{meta.label}</Badge>
                      <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                        {SUGGESTION_KIND_LABELS[item.kind] || "Sugestão"}
                        {item.area
                          ? ` · ${SUGGESTION_AREA_LABELS[item.area] || item.area}`
                          : ""}
                      </span>
                      {item.mergedIntoId ? (
                        <span className="text-[11px] text-slate-400">
                          juntada à #{item.mergedIntoId}
                        </span>
                      ) : null}
                    </span>
                    <span className="mt-1 line-clamp-2 block break-words text-sm text-slate-800">
                      {item.message}
                    </span>
                    <span className="block text-[11px] text-slate-500">
                      {item.professional?.name
                        ? `${item.professional.name} · `
                        : ""}
                      {formatDate(item.createdAt)}
                    </span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </Card>

      {openId ? (
        <SuggestionDrawer
          suggestionId={openId}
          onClose={() => setOpenId(null)}
          onOpen={setOpenId}
        />
      ) : null}
    </>
  );
};

export default ClientSuggestions;
